import type { CSSProperties, ReactNode } from "react";

import { cx, styled } from "simplydo/react/styled";
import { containerWidths } from "simplydo/react/theme";

export type ContainerProps = {
  fluid?: boolean;
  text?: boolean;
  textAlign?: "left" | "center" | "right" | "justified";
  children?: ReactNode;
  className?: string;
  style?: CSSProperties;
};

const StyledContainer = styled.div<{ $textAlign: string }>`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: ${containerWidths.default}px;
  margin-left: auto;
  margin-right: auto;
  padding-left: 1rem;
  padding-right: 1rem;
  box-sizing: border-box;
  text-align: ${({ $textAlign }) => $textAlign};
  align-items: stretch;

  &.is-fluid {
    flex: 1;
    max-width: none;
    padding-left: 0;
    padding-right: 0;
  }

  &.is-text:not(.is-fluid) {
    max-width: ${containerWidths.text}px;
  }
`;
const ContainerComponent = (props: ContainerProps) => {
  const { fluid, text, textAlign, children, className, style } = props;
  return (
    <StyledContainer
      className={cx(fluid && "is-fluid", text && "is-text", className)}
      style={style}
      $textAlign={textAlign === "justified" ? "justify" : textAlign || "left"}
    >
      {children}
    </StyledContainer>
  );
};

export const Container = styled(ContainerComponent)``;
